export const selectAuth = (state) => state.data.auth;
export const selectAuthUsername = (state) => state.data.auth.username;
export const selectAuthStatus = (state) => state.data.auth.status;
export const selectAuthEmail = (state) => state.data.auth.email;
